import React, { useState, useEffect } from "react";
import Pagination from "../../../common/pagination";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { paginate } from "../../../utils/paginate";
import Delete from "./../../../common/delete";
import Table from "./../../../common/table";
import getService from "../../../services/getService";
import { toast } from "react-toastify";
import deleteService from "../../../services/deleteService";
import UpdateUserStatus from "../../../common/UpdateUserStatus";
import postService from "../../../services/postService";
import { CSVLink } from "react-csv";
import SearchBox from "./../../../common/searchBox";

const UserTable = () => {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [id, setId] = useState(null);

  const fetchUsers = async () => {
    const user = await getService.handleUserList();
    setUsers(user);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleDelete = async (id) => {
    try {
      await deleteService.DeleteUser({ id });
      setCurrentPage(1);
      fetchUsers();
    } catch (error) {
      toast.error(error);
    }
    setId(null);
  };

  const handleStatus = async (id) => {
    try {
      await postService.PostUpdateStatus(id);
      setCurrentPage(1);
      fetchUsers();
    } catch (error) {
      toast.error(error);
    }
    setId(null);
  };

  const getPagedData = () => {
    let filtered = users;
    if (searchQuery)
      filtered = users.filter((m) =>
        m.email.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    else filtered = users;

    const user = paginate(filtered, currentPage, pageSize);
    return { totalCount: users.length, data: user };
  };

  const { length: count } = users;

  const { totalCount, data: user } = getPagedData();

  const columns = [
    {
      key: "",
      label: "S.No",
      content: (user) => <p>{users.indexOf(user) + 1}</p>,
    },
    { path: "name", label: "Name" },
    { path: "email", label: "Email" },
    { path: "mobile", label: "Mobile" },
    {
      path: "orderstatus",
      label: "User Status",
      content: (user) => (
        <>
          <UpdateUserStatus
            id={id}
            ItemId={user}
            setId={setId}
            onClick={handleStatus}
          />
          {/* <span className="badge text-bg-secondary">{user.status}</span> */}
        </>
      ),
    },
    {
      key: "Action",
      label: "Action",
      content: (user) => (
        <>
          <button
            class="btn btn-info btn-xs m-b-5 custom_btn"
            data-toggle="tooltip"
            data-placement="left"
            title="Update"
            onClick={() => {
              navigate(`/admin/userform/${user.id}`);
            }}
          >
            <i class="pe-7s-note" aria-hidden="true"></i>
          </button>
          <button
            class="btn btn-success btn-xs m-b-5 custom_btn"
            data-toggle="tooltip"
            data-placement="left"
            title="Update"
            onClick={() => {
              navigate(`/admin/userdetails/${user.id}`);
            }}
          >
            <i class="fa fa-eye" aria-hidden="true"></i>
          </button>
          <Delete
            id={id}
            ItemId={user.id}
            setId={setId}
            onClick={handleDelete}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchUsers();
  }, []);

  console.log("users", users);

  if (count === 0) return <p>There are no orders in the database.</p>;

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>Users List </h4>
              </div>
              <CSVLink data={users} className="btn btn-outline-success">
                Download Report
              </CSVLink>
            </div>
            <div class="row">
              <div class="col-sm-7">
                <SearchBox value={searchQuery} onChange={handleSearch} />
              </div>
            </div>

            <div class="panel-body">
              <Table columns={columns} data={user} />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div
            class="dataTables_info"
            id="supplierList_info"
            role="status"
            aria-live="polite"
          >
            Showing {totalCount} entries in the Database
          </div>
        </div>
        <div class="col-sm-7">
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default UserTable;
